import { render } from "./tubeList.vue?vue&type=template&id=cbfcd1f2"
import script from "./tubeList.vue?vue&type=script&lang=js"
export * from "./tubeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__